import * as React from 'react';
import { unmountComponentAtNode } from 'react-dom';

import 'rxjs';
import 'rxjs/add/observable/dom/ajax';

import SignatureCanvas from 'react-signature-canvas';
import { Store } from 'redux';
import sendFiles from 'botframework-webchat-core/lib/actions/sendFiles';
// import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';

// import * as PDFLib from 'pdf-lib/dist/pdf-lib.min.js';
// import * as pdfjsLib from 'pdfjs-dist/build/pdf.js';
// import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.mjs';
import { WebChatState } from '../WebChatContext';

export interface DruidDocumentViewerProps {
    documentSrc: string;
    store: Store<WebChatState>;
    determinedDir: string;
    fileName: string;
    signatureFieldText: string;
    signatureScale: string;
    signButtonName: string;
    cancelButtonName: string;
    saveButtonName: string;
    uploadButtonName: string;
    signatureColorCode: string; 
}

declare type SignaturePages = { [key: number]: { [key: number]: SignatureItem[] } };
declare type SignatureItem =  { signatureLeft: number, signatureTop: number, pageNo: number, signatureType: number };

export class DruidDocumentViewer extends React.Component<DruidDocumentViewerProps, {}> {
    // private signatureLeft: number[] = [];
    // private signatureTop: number[] = [];
    private pagesWithSignature: SignaturePages = {};
    private allSignatures: SignatureItem[] = [];
    private signatureFieldTextSplit: string[] = [];
    private signatureFieldTextSplitByPipe: string[] = [];
    // private pngImageBytes: [];
    private signaturePage: number = 0;
    private scale: number = 0;
    private onResizeHandler;
    private pngImageBytes: string[] = [];

    private sigPad: any[] = [];
    private pdfInstance: any;
    private canvasHeight: number = 0;
    private signatureFieldTextHeight: number = 0;
    private privateScale: number = 0;
    private initialMetaViewPort: Element | undefined = undefined;
    private get buttonFontSize(): number {
        return this.privateScale * 12;
    }

    constructor(props: DruidDocumentViewerProps) {
        super(props);
    }

    async componentDidMount() {

        // const pdfjsLib = await import(
        //     /* webpackChunkName: "pdfjs-dist" */ 
        //     'pdfjs-dist/webpack.mjs');
        const pdfjsLib = await import(
            /* webpackChunkName: "pdfjs-dist" */ 
            'pdfjs-dist/build/pdf.mjs');
        // this is just a preload
        await import(
            /* webpackChunkName: "pdflib" */ 
            'pdf-lib/dist/pdf-lib.min.js');

        Array.from(document.getElementsByClassName('signaturePadContainer')).forEach(elem => (elem as any).style.display = 'none');

        const width = document.documentElement.clientWidth;
        if (width <= 450) {
            this.privateScale = 0.4;
        } else if (width <= 700) {
            this.privateScale = 0.7;
        } else if (width <= 1000) {
            this.privateScale = 1.0;
        } else {
            this.privateScale = 1.5;
        }
        this.scale = 1.5;

        const { default: pdfjsWorker } = await import(
            /* webpackChunkName: "pdfjsWorker" */ 
            'pdfjs-dist/build/pdf.worker.min.mjs');

        if (typeof pdfjsWorker === 'string') {
            const pdfjsWorkerBlob = new Blob([pdfjsWorker], {type: 'application/javascript' });
            const pdfjsWorkerBlobURL = URL.createObjectURL(pdfjsWorkerBlob);
            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorkerBlobURL;
        } else {
            pdfjsLib.GlobalWorkerOptions.workerSrc = './pdf.worker.js'; // external settup
        }

        const loadingTask = pdfjsLib.getDocument({ url: this.props.documentSrc, isEvalSupported: false});
        this.signatureFieldTextSplit = this.props.signatureFieldText.split(' ');
        this.signatureFieldTextSplitByPipe = this.props.signatureFieldText.split('|');
        new Promise<SignaturePages>((promise) => {
            loadingTask.promise.then(async (pdf) => {
                this.pdfInstance = pdf;
                const container = document.getElementById('pdf-container');
                // const modal = document.getElementById('druid_jsDocumentViewer_v2');
                this.onResizeHandler = this.onResize.bind(this);
                window.addEventListener('resize', this.onResizeHandler);

                // Loop from 1 to total_number_of_pages in PDF document
                for (let i = 1; i <= pdf.numPages; i++) {
                    // Get desired page
                    const page = await pdf.getPage(i);
                    const viewport = page.getViewport({ scale: this.scale });
                    const div = document.createElement('div');
                    // Set id attribute with page-#{pdf_page_number} format
                    div.setAttribute('id', 'page-' + (page._pageIndex + 1));
                    div.addEventListener('click', event => {
                       
                    });
                    // This will keep positions of child elements as per our needs
                    div.setAttribute('style', 'position: relative');
                    // Append div within div#container
                    container?.appendChild(div);
                    // Create a new Canvas element
                    const canvas = document.createElement('canvas');
                    // Append Canvas within div#page-#{pdf_page_number}
                    div.appendChild(canvas);
                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    this.canvasHeight = canvas.height;
                    canvas.width = viewport.width;
                    const renderContext = {
                        canvasContext: context,
                        viewport
                    };
                    const items = await page.getTextContent();
                    if (items.items.length > 0) {
                        this.signatureFieldTextSplitByPipe.forEach((signatureFieldTextByPipe, pipeIdx) => {
                            items.items.forEach((textItem: any, index) => {
                                if (textItem.str === signatureFieldTextByPipe || textItem.str === this.signatureFieldTextSplit[0]) {
                                    let proceedWithCheck = true;
                                    if (textItem.str === this.signatureFieldTextSplit[0] && this.signatureFieldTextSplit.length > 1) {
                                        proceedWithCheck = items.items.slice(index, index + (this.signatureFieldTextSplit.length * 2 - 1)).map((ti: any) => ti.str).join('') === signatureFieldTextByPipe;
                                    }

                                    if (proceedWithCheck) {
                                        this.signaturePage = page._pageIndex;
                                        const transformArray = pdfjsLib.Util.transform(page.getViewport({ scale: this.scale }).transform, textItem.transform);
                                        this.signatureFieldTextHeight = textItem.height;

                                        // promise(this.signaturePage);
                                        if (!this.pagesWithSignature[this.signaturePage]) {
                                            this.pagesWithSignature[this.signaturePage] = {};
                                        }

                                        if (!this.pagesWithSignature[this.signaturePage][pipeIdx]) {
                                            this.pagesWithSignature[this.signaturePage][pipeIdx] = [];
                                            //{signatureLeft: number, signatureTop: number}[]
                                        }

                                        this.pagesWithSignature[this.signaturePage][pipeIdx] = [...this.pagesWithSignature[this.signaturePage][pipeIdx], ...[{ signatureLeft: transformArray[4], signatureTop: transformArray[5], pageNo: this.signaturePage, signatureType: pipeIdx }]];
                                        this.allSignatures = [...this.allSignatures, { signatureLeft: transformArray[4], signatureTop: transformArray[5], pageNo: this.signaturePage, signatureType: pipeIdx }];
                                        this.forceUpdate();
                                    }
                                }
                            });
                        });

                    }
                    // Render PDF page
                    page.render(renderContext as any);
                }

                promise(this.pagesWithSignature);

            }).catch(ex => {
                this.closeCustomModal(true);
            });


        }).then((pagesWithSignature: SignaturePages) => {

            Object.keys(pagesWithSignature).map(ps => parseInt(ps)).forEach(pageNo => {
                const pageElement = document.getElementById(`page-${pageNo + 1}`);
                const pageObject = pagesWithSignature[pageNo];
                Object.entries(pageObject).map(([key, value]) => ({ signatureIndex: parseInt(key), signaturePositions: value })).forEach((signature) => {

                    const slIndex = signature.signatureIndex;

                    (signature.signaturePositions as any).forEach((sp) => {
                        const { signatureLeft, signatureTop } = sp;
                        const modal = document.getElementById('druid_jsDocumentViewer_v2');
                        const canvas = modal?.querySelectorAll('canvas').item(0);
                        const signingButton = document.createElement('button');
                        const pdfContainer = document.getElementById('pdf-container');
                        modal && canvas && signingButton.setAttribute('style', 'position: absolute; z-index: 1200; left:' + (signatureLeft * canvas.offsetWidth / canvas.width + (modal.offsetWidth > canvas.offsetWidth ? (modal.offsetWidth - canvas.offsetWidth) / 2 - (modal.offsetWidth - pdfContainer!.offsetWidth) / 2 : 0) + 'px; bottom:' + Math.round(0.025 * modal.offsetHeight + canvas.offsetHeight - (signatureTop * canvas.offsetHeight / canvas.height - this.signatureFieldTextHeight * this.privateScale)) + 'px; font-size: ' + this.buttonFontSize + 'px'));
                        signingButton.setAttribute('id', this.getSigningButtonId(sp));
                        signingButton.classList.add(`signingButton_${slIndex}`, 'btn', 'btn-info');
                        signingButton.innerHTML = this.props.signButtonName || 'Sign here';
                        signingButton.addEventListener('click', event => {
                            this.zoomOutMobile();

                            const saveButton = document.getElementById(`signaturePadSave_${slIndex}`);
                            // var newSaveButton = saveButton.cloneNode(true);
                            // (saveButton as any).replaceWith(newSaveButton);
                            // const clickYPosition = event.pageY;
                            document.getElementById(`signaturePadContainer_${slIndex}`)!.style.display = 'block';
                            document.getElementById(`signaturePadContainer_${slIndex}`)!.style.top = `${document.getElementById('druid_jsDocumentViewer_v2')!.scrollTop + document.getElementById(`signaturePadContainer_${slIndex}`)!.clientHeight}px`;
                            this.sigPad[slIndex].getCanvas().height = document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientHeight;
                            this.sigPad[slIndex].getCanvas().width = document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientWidth;

                            saveButton?.addEventListener('click', event => {
                                if (!this.sigPad[slIndex].isEmpty()) {
                                    // document.getElementById(`signingButton_${slIndex}`).style.display = 'none';
                                    Array.from(document.getElementsByClassName(`signingButton_${slIndex}`)).forEach(elem => (elem as any).style.display = 'none');
                                    this.pngImageBytes[slIndex] = this.sigPad[slIndex].getTrimmedCanvas().toDataURL('image/png');

                                    Array.from(modal!.querySelectorAll(`.signature-image_${slIndex}`)).forEach(newSignatureImageElement => {
                                        const pageNumberAttribute = parseInt(newSignatureImageElement.attributes.getNamedItem('page-number')!.value);
                                        const currentPageElement = document.getElementById(`page-${pageNumberAttribute + 1}`);
                                        newSignatureImageElement.setAttribute('draggable', 'false');
                                        // const img = document.getElementById('signature-image');
                                        // newSignatureImageElement.setAttribute('style', `position: absolute;transform:scale(${this.props.signatureScale}); cursor: pointer; left:${signatureLeft * canvas.offsetWidth / canvas.width + (modal.offsetWidth > canvas.offsetWidth ? (modal.offsetWidth - canvas.offsetWidth) / 2 - (modal.offsetWidth - pdfContainer.offsetWidth) / 2 : 0)}px; bottom:${Math.round(0.025 * modal.offsetHeight + canvas.offsetHeight - (signatureTop * canvas.offsetHeight / canvas.height - this.signatureFieldTextHeight * this.privateScale))}px; height: ${this.privateScale * 40}px; width: ${this.privateScale * 80}px; background-color: transparent`);
                                        // Send data to server instead...
                                        newSignatureImageElement.setAttribute('src', this.pngImageBytes[slIndex]);

                                        currentPageElement?.appendChild(newSignatureImageElement);
                                        (newSignatureImageElement as HTMLImageElement).onclick = (event) => {
                                            this.zoomOutMobile();
                                            document.getElementById(`signaturePadContainer_${slIndex}`)!.style.display = 'block';
                                            // this.sigPad.clear();
                                            // this.sigPad.fromDataURL(this.pngImageBytes[slIndex], { ratio: 3});
                                            if (this.sigPad[slIndex].getCanvas().height !== document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientHeight && document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientHeight !== 0) {
                                                this.sigPad[slIndex].getCanvas().height = document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientHeight;
                                            }

                                            if (this.sigPad[slIndex].getCanvas().width !== document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientWidth && document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientWidth !== 0) {
                                                this.sigPad[slIndex].getCanvas().width = document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientWidth;
                                            }
                                        }
                                    });
                                    document.getElementById(`signaturePadContainer_${slIndex}`)!.style.display = 'none';
                                    document.getElementById('druid-icon-save')!.style.display = 'inline-block';
                                }
                            });
                        });

                        pageElement?.appendChild(signingButton);
                    });


                });
            });




        });
    }

    changeViewPort(key, val) {
        const reg = new RegExp(key, 'i');
        let oldval = (document.querySelector('meta[name="viewport"]') as any).content;
        const newval = reg.test(oldval) ? oldval.split(/,\s*/).map(v => reg.test(v) ? key + '=' + val : v).join(', ') : oldval += ', ' + key + '=' + val;
        (document.querySelector('meta[name="viewport"]') as any).content = newval;
    }

    zoomOutMobile() {
        this.initialMetaViewPort = document.querySelectorAll('meta[name=viewport]')[0];
        if (this.initialMetaViewPort) {
            this.initialMetaViewPort.remove();
        }
        document.head.insertAdjacentHTML('beforeend', '<meta name="viewport" content="width=device-width, maximum-scale=1.0, user-scalable=0">');

        document.querySelectorAll('meta[name=viewport]')[0].remove();
        document.head.insertAdjacentHTML('beforeend', '<meta name="viewport" content="width=device-width, initial-scale=yes">');
    }

    onResize() {
        const modal = document.getElementById('druid_jsDocumentViewer_v2');
        const canvas = modal?.querySelector('canvas'); // pdf canvas
        const pdfContainer = document.getElementById('pdf-container');

        this.sigPad.forEach((sp, slIndex) => {
            sp.getCanvas().height  = document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientHeight; // signpad canvas
            sp.getCanvas().width = document.getElementById(`signaturePadCanvasContainer_${slIndex}`)!.clientWidth;
        })
        

        const width = document.documentElement.clientWidth;
        if (width <= 450) {
            this.privateScale = 0.4;
        } else if (width <= 700) {
            this.privateScale = 0.7;
        } else if (width <= 1000) {
            this.privateScale = 1.0;
        } else {
            this.privateScale = 1.5;
        }

        this.allSignatures.forEach(sl => {
            const signatureImage = document.getElementById(this.getSignatureImageId(sl));
            const signingButton = document.getElementById(this.getSignatureImageId(sl));
            if (!signatureImage || (signatureImage.getAttribute('src') === null || signatureImage.getAttribute('src') === '')) {
                signingButton && canvas && modal && pdfContainer && signingButton.setAttribute('style', 'position: absolute; z-index: 1200; left:' + (sl.signatureLeft * canvas.offsetWidth / canvas.width + (modal.offsetWidth > canvas.offsetWidth ? (modal.offsetWidth - canvas.offsetWidth ) / 2 - (modal.offsetWidth - pdfContainer.offsetWidth)/2 : 0) + 'px; bottom:' + Math.round(0.025 * modal.offsetHeight + canvas.offsetHeight - (sl.signatureTop * canvas.offsetHeight / canvas.height - this.signatureFieldTextHeight * this.privateScale)) + 'px; font-size: ' + this.buttonFontSize + 'px' ));
            } else {
                if (signatureImage) {
                    canvas && modal && pdfContainer && signatureImage.setAttribute('style', `position: absolute;transform:scale(${this.props.signatureScale}); cursor: pointer; left:${sl.signatureLeft * canvas.offsetWidth / canvas.width + (modal.offsetWidth > canvas.offsetWidth ? (modal.offsetWidth - canvas.offsetWidth) / 2 - (modal.offsetWidth - pdfContainer.offsetWidth)/2 : 0)}px; bottom:${Math.round(0.025 * modal.offsetHeight + canvas.offsetHeight - (sl.signatureTop * canvas.offsetHeight / canvas.height - this.signatureFieldTextHeight * this.privateScale))}px; height: ${this.privateScale * 40}px; width: ${this.privateScale * 80}px; background-color: transparent`);
                }
            }
        })
        
    }

    closeCustomModal(isCancel?: true) {
        try {
            window.removeEventListener('resize', this.onResizeHandler);
            const CustomModalWindow = document.getElementById('druid_jsDocumentViewer_v2');

            if (!!CustomModalWindow) {
                CustomModalWindow.classList ? CustomModalWindow.classList.remove('open') : CustomModalWindow.className = CustomModalWindow.className.replace(new RegExp('(^|\\b)' + 'open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');

                // $(document).unbind('keyup.Escape');

                if (!!document.getElementById('druidWebchatSignDocumentModal')) {
                    unmountComponentAtNode(document.getElementById('druidWebchatSignDocumentModal')!);
                    const toDelElem = document.getElementById('druidWebchatSignDocumentModal');
                    toDelElem?.parentNode?.removeChild(toDelElem);
                }

                if (this.pdfInstance) {
                    this.pdfInstance.destroy();
                }
                if (isCancel) {
                    // const storeState = this.props.store.getState();
                    
                    this.props.store.dispatch({
                        type: 'WEB_CHAT/SEND_EVENT',
                        payload: {
                            name: 'CancelUpload',
                            value: {}
                        }
                      });
                    // storeState.directlineInstance?.postActivity({
                    //     type: 'event',
                    //     name: 'CancelUpload',
                    //     from: {
                    //         id: storeState.directlineOptions.use
                    //     },
                    //     value: {}
                    // }).subscribe();
                }
                localStorage.removeItem('Druid_SignDocument_ActivityId');
            }
        } catch (ex) {
            console.error(ex);
        }
    }

    async saveDocument() {

        // Fetch an existing PDF document
        try {
            const existingPdfBytes = await fetch(this.props.documentSrc).then(res => res.arrayBuffer());
            const PDFLib = await import(
                /* webpackChunkName: "pdflib" */ 
                'pdf-lib/dist/pdf-lib.min.js');

            // Load a PDFDocument from the existing PDF bytes
            const pdfDoc = await PDFLib.PDFDocument.load(existingPdfBytes);
            new Promise((resolve, reject) => {
                this.allSignatures.forEach(async (signature, index) => {
                    if(this.pngImageBytes[signature.signatureType]) {
                        const arrayBuffer = await fetch(this.pngImageBytes[signature.signatureType]).then(res => res.arrayBuffer());
                        const pngImage = await pdfDoc.embedPng(arrayBuffer);

                        const pages = pdfDoc.getPages();
                        const page = pages[signature.pageNo];

                        page.drawImage(pngImage, {
                            x: signature.signatureLeft / this.scale,
                            y: (page.getHeight() - signature.signatureTop / this.scale),
                            width: 80 * parseFloat(this.props.signatureScale), // to sync with others
                            height: 40 * parseFloat(this.props.signatureScale)
                        });
                    } else {
                        resolve(false)
                    }
                    
                    if(index === this.allSignatures.length - 1) {
                        resolve(true);
                    }
                    
                });
            }).then(async (resp) => {
                if(!resp) return;
                // Serialize the PDFDocument to bytes (a Uint8Array)
                const pdfBytes = await pdfDoc.save();
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                const file = new File([blob], this.props.fileName, { type: 'application/pdf' }); // to change file name
                this.props.store.dispatch(sendFiles([{
                    name: file.name,
                    size: file.size,
                    url: window.URL.createObjectURL(file)
                }]));
                this.closeCustomModal();
            });
        } catch (ex) {
            console.error(ex);
        }

    }

    private getSignatureImageId(sl: SignatureItem) {
        return `${sl.pageNo}_${sl.signatureLeft}_${sl.signatureTop}_signature-image`;
    }

    private getSigningButtonId(sl: SignatureItem) {
        return `signingButton_${sl.pageNo}_${sl.signatureLeft}_${sl.signatureTop}`;
    }

    render() {

        // $(document).on('keyup.Escape', ()=> {
        //     this.closeCustomModal();
        // });

        const modal = document.getElementById('druid_jsDocumentViewer_v2');
        const canvas = modal && modal.querySelectorAll('canvas').item(0);
        const pdfContainer = document.getElementById('pdf-container');

        return (<div id="druid_jsDocumentViewer_v2" className={`documentViewer ${ this.props.determinedDir !== "ltr" ? 'wc-druid-rtl-layout' : ''}`}>
            <div className="documentViewer__overlay jsOverlay"></div>
            <div className="documentViewer__container">
                {/* <img src={this.props.documentSrc} className="pictureViewer_imgElem"></img> */}

                <div id="pdf-container"></div>
                {
                    modal && canvas && this.allSignatures.map((sl, idx) =>
                    (<img key={this.getSignatureImageId(sl)} id={this.getSignatureImageId(sl)} page-number={sl.pageNo} draggable={false}
                        className={`signature-image_${sl.signatureType}`}
                        style={{
                            position: 'absolute', transform: `scale(${this.props.signatureScale})`, cursor: 'pointer',
                            left: `${sl.signatureLeft * canvas.offsetWidth / canvas.width + (modal.offsetWidth > canvas.offsetWidth ? (modal.offsetWidth - canvas.offsetWidth) / 2 - (modal.offsetWidth - pdfContainer!.offsetWidth) / 2 : 0)}px`,
                            bottom: `${Math.round(0.025 * modal.offsetHeight + canvas.offsetHeight - (sl.signatureTop * canvas.offsetHeight / canvas.height - this.signatureFieldTextHeight * this.privateScale))}px`,
                            // height: `${this.privateScale * 40}px`,
                            width: `${this.privateScale * 80}px`,
                            backgroundColor: 'transparent'
                        }}
                    >

                    </img>)
                    )

                }

                {

                    this.signatureFieldTextSplitByPipe && this.signatureFieldTextSplitByPipe.map((sl, idx) => (<div key={`${idx}_signaturePadContainer`} className="signaturePadContainer" id={`signaturePadContainer_${idx}`} style={{ display: "none" }}>
                        <div className="signaturePadCanvasContainer" id={`signaturePadCanvasContainer_${idx}`}>
                            <SignatureCanvas penColor={this.props.signatureColorCode || "#000000"} canvasProps={{ width: 630, height: 320, className: 'sigCanvas' }} minWidth={3} maxWidth={3} ref={ref => { this.sigPad[idx] = ref; }}></SignatureCanvas>
                        </div>
                        <div className="signaturePadActions">
                            <button onClick={e => this.sigPad[idx].clear()} className="btn btn-danger btn-clear">
                                Clear
                            </button>
                            <button className="btn btn-info btn-save" id={`signaturePadSave_${idx}`}>
                                { this.props.saveButtonName || 'Save' }
                            </button>
                            <button className="btn btn-default btn-cancel" onClick={e => document.getElementById(`signaturePadContainer_${idx}`)!.style.display = 'none'} >
                                { this.props.cancelButtonName || 'Cancel' }
                            </button>

                        </div>
                    </div>))

                }

                
                {
                    !this.props.uploadButtonName ?
                        (
                            <i onClick={() => this.saveDocument()} title="Save" id="druid-icon-save" className="druid-icon-save">
                                <img src="data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ1cGxvYWQiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS11cGxvYWQgZmEtdy0xNiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yOTYgMzg0aC04MGMtMTMuMyAwLTI0LTEwLjctMjQtMjRWMTkyaC04Ny43Yy0xNy44IDAtMjYuNy0yMS41LTE0LjEtMzQuMUwyNDIuMyA1LjdjNy41LTcuNSAxOS44LTcuNSAyNy4zIDBsMTUyLjIgMTUyLjJjMTIuNiAxMi42IDMuNyAzNC4xLTE0LjEgMzQuMUgzMjB2MTY4YzAgMTMuMy0xMC43IDI0LTI0IDI0em0yMTYtOHYxMTJjMCAxMy4zLTEwLjcgMjQtMjQgMjRIMjRjLTEzLjMgMC0yNC0xMC43LTI0LTI0VjM3NmMwLTEzLjMgMTAuNy0yNCAyNC0yNGgxMzZ2OGMwIDMwLjkgMjUuMSA1NiA1NiA1Nmg4MGMzMC45IDAgNTYtMjUuMSA1Ni01NnYtOGgxMzZjMTMuMyAwIDI0IDEwLjcgMjQgMjR6bS0xMjQgODhjMC0xMS05LTIwLTIwLTIwcy0yMCA5LTIwIDIwIDkgMjAgMjAgMjAgMjAtOSAyMC0yMHptNjQgMGMwLTExLTktMjAtMjAtMjBzLTIwIDktMjAgMjAgOSAyMCAyMCAyMCAyMC05IDIwLTIweiI+PC9wYXRoPjwvc3ZnPg=="></img>
                            </i>
                        ):
                        (
                            <button onClick={() => this.saveDocument()} className="btn btn-info btn-save druid-icon-save druid-icon-with-text"  id="druid-icon-save">
                                <img src="data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ1cGxvYWQiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS11cGxvYWQgZmEtdy0xNiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yOTYgMzg0aC04MGMtMTMuMyAwLTI0LTEwLjctMjQtMjRWMTkyaC04Ny43Yy0xNy44IDAtMjYuNy0yMS41LTE0LjEtMzQuMUwyNDIuMyA1LjdjNy41LTcuNSAxOS44LTcuNSAyNy4zIDBsMTUyLjIgMTUyLjJjMTIuNiAxMi42IDMuNyAzNC4xLTE0LjEgMzQuMUgzMjB2MTY4YzAgMTMuMy0xMC43IDI0LTI0IDI0em0yMTYtOHYxMTJjMCAxMy4zLTEwLjcgMjQtMjQgMjRIMjRjLTEzLjMgMC0yNC0xMC43LTI0LTI0VjM3NmMwLTEzLjMgMTAuNy0yNCAyNC0yNGgxMzZ2OGMwIDMwLjkgMjUuMSA1NiA1NiA1Nmg4MGMzMC45IDAgNTYtMjUuMSA1Ni01NnYtOGgxMzZjMTMuMyAwIDI0IDEwLjcgMjQgMjR6bS0xMjQgODhjMC0xMS05LTIwLTIwLTIwcy0yMCA5LTIwIDIwIDkgMjAgMjAgMjAgMjAtOSAyMC0yMHptNjQgMGMwLTExLTktMjAtMjAtMjBzLTIwIDktMjAgMjAgOSAyMCAyMCAyMCAyMC05IDIwLTIweiI+PC9wYXRoPjwvc3ZnPg=="></img>
                                { this.props.uploadButtonName }
                            </button>
                        )
                }
                <i onClick={() => { this.closeCustomModal(true); }} title="Close" className="druid-icon-close">
                    <img src="data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ0aW1lcyIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLXRpbWVzIGZhLXctMTEiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzUyIDUxMiI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMjQyLjcyIDI1NmwxMDAuMDctMTAwLjA3YzEyLjI4LTEyLjI4IDEyLjI4LTMyLjE5IDAtNDQuNDhsLTIyLjI0LTIyLjI0Yy0xMi4yOC0xMi4yOC0zMi4xOS0xMi4yOC00NC40OCAwTDE3NiAxODkuMjggNzUuOTMgODkuMjFjLTEyLjI4LTEyLjI4LTMyLjE5LTEyLjI4LTQ0LjQ4IDBMOS4yMSAxMTEuNDVjLTEyLjI4IDEyLjI4LTEyLjI4IDMyLjE5IDAgNDQuNDhMMTA5LjI4IDI1NiA5LjIxIDM1Ni4wN2MtMTIuMjggMTIuMjgtMTIuMjggMzIuMTkgMCA0NC40OGwyMi4yNCAyMi4yNGMxMi4yOCAxMi4yOCAzMi4yIDEyLjI4IDQ0LjQ4IDBMMTc2IDMyMi43MmwxMDAuMDcgMTAwLjA3YzEyLjI4IDEyLjI4IDMyLjIgMTIuMjggNDQuNDggMGwyMi4yNC0yMi4yNGMxMi4yOC0xMi4yOCAxMi4yOC0zMi4xOSAwLTQ0LjQ4TDI0Mi43MiAyNTZ6Ij48L3BhdGg+PC9zdmc+"></img>
                </i>
                {/* className="fa fa-2x fa-times icon-close" */}
                {/* <a href={this.imageSrc} download>
                <i  className="fa fa-2x fa-download druid-icon-download" title="Download" ></i>
                </a> */}
                {/* <button className="button"  style={{"verticalAlign":"middle"}}></button> */}
            </div>

        </div>);
    }
}
